const jobs = {
  forms: {
    information: {
      reservationDetails: {
        fields: {
          from: 'Local de Recolhimento',
          to: 'Local de Deixa',
          seat: 'Pacotes',
        },
      },
    },
  },

  table: {
    headers: {
      seats: 'Quantidade de Item',
      from: 'Local de Recolhimento',
      to: 'Local de Deixa',
      passenger: 'Nome do Destinatário',
    },
    statuses: {
      picked: 'Saiu para Entrega',
      dropped: 'Entregue',
      noshow: 'Falha na exibição',
    },
  },
};

export default jobs;
